import React from 'react'

function PartnerCard({data}) {
  return (
    <div className='min-w-[200px] max-w-[200px] flex flex-col justify-between  h-[180px] max-[400px]:w-full max-[400px]:min-w-full max-[400px]:max-w-full'>
        <img className='rounded-[10px] w-full max-h-[150px] mt-auto mb-auto flex self-center' src={data?.image_full_url} />
        <h3 className='text-center mt-[7px] font-[500] text-[14px]'>{data?.translate?.title}</h3>
    </div>
  )
}

export default PartnerCard